/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ERPProcountorIntegrationSettings'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ERPProcountorIntegrationSettings'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPProcountorIntegrationSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ERPProcountorIntegrationSettings);
  }
}(this, function(ApiClient, ERPProcountorIntegrationSettings) {
  'use strict';

  /**
   * ERPProcountorIntegrationSettings service.
   * @module api/ERPProcountorIntegrationSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ERPProcountorIntegrationSettingsApi. 
   * @alias module:api/ERPProcountorIntegrationSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the eRPProcountorIntegrationSettingsAddPut operation.
     * @callback module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPProcountorIntegrationSettings} body 
     * @param {module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.eRPProcountorIntegrationSettingsAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPProcountorIntegrationSettingsAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPProcountorIntegrationSettingsAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ERPProcountorIntegrationSettings/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPProcountorIntegrationSettingsDeleteGet operation.
     * @callback module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPProcountorIntegrationSettingsDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPProcountorIntegrationSettingsDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling eRPProcountorIntegrationSettingsDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPProcountorIntegrationSettings/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPProcountorIntegrationSettingsEditPut operation.
     * @callback module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPProcountorIntegrationSettings} body 
     * @param {Integer} primaryKey 
     * @param {module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPProcountorIntegrationSettingsEditPut = function(_4SAPIAppID, body, primaryKey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPProcountorIntegrationSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPProcountorIntegrationSettingsEditPut";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling eRPProcountorIntegrationSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPProcountorIntegrationSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPProcountorIntegrationSettingsLoadAllGet operation.
     * @callback module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ERPProcountorIntegrationSettings>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ERPProcountorIntegrationSettings>}
     */
    this.eRPProcountorIntegrationSettingsLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPProcountorIntegrationSettingsLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ERPProcountorIntegrationSettings];

      return this.apiClient.callApi(
        '/ERPProcountorIntegrationSettings/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPProcountorIntegrationSettingsUpdateProcountorDataGet operation.
     * @callback module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsUpdateProcountorDataGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * updateProcountorData
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPProcountorIntegrationSettingsApi~eRPProcountorIntegrationSettingsUpdateProcountorDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPProcountorIntegrationSettingsUpdateProcountorDataGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPProcountorIntegrationSettingsUpdateProcountorDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPProcountorIntegrationSettings/updateProcountorData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
